import React, { useState, useEffect } from 'react';

import { useMutation } from '@tanstack/react-query';

import Switch from '../../../Switch';

import UserService from '../../../../services/UserService';

export default function ToggleUserEnabledStatus({ user, refetch, disabled }) {
  const [isEnabled, setIsEnabled] = useState(true);

  useEffect(() => {
    setIsEnabled(user.isEnabled);
  }, [user.isEnabled]);

  const { mutate: toggleUserEnabledStatus } = useMutation({
    mutationFn: () => UserService.toggleUserEnabledStatus(user.id),
    onSuccess: () => {
      refetch();
    },
    onError: (error) => {
      console.log(error);
      setIsEnabled((prevState) => !prevState);
    },
  });

  return (
    <div>
      <Switch
        checked={isEnabled}
        onChange={() => {
          setIsEnabled((prevState) => !prevState);
          toggleUserEnabledStatus();
        }}
        disabled={disabled}
      />
    </div>
  );
}
